exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".confirmButton__COM-module___23xvl {\n    background-color: #e7faf5;\n    color: #0acf97;\n    box-shadow: none;\n    margin: 0;\n    border-radius: 0.375rem;\n    padding: 8px 12px;\n  }\n  \n  .confirmButton__COM-module___23xvl:hover {\n    background-color: #0acf97;\n    color: #fff;\n    box-shadow: none;\n  }\n\n  @media (max-width: 762px) {\n    .cellButtonContainer__COM-module___3MVY4 {\n      margin-top: 26px;\n    }\n    .cell__COM-module___NXd4u {\n      padding-bottom: 12px;\n    }\n  }", ""]);

// Exports
exports.locals = {
	"confirmButton": "confirmButton__COM-module___23xvl",
	"cellButtonContainer": "cellButtonContainer__COM-module___3MVY4",
	"cell": "cell__COM-module___NXd4u"
};